import AddressSheet from './addressSheet';
import CareemAddressSheet from './careemAddressSheet';

export const AddressComponents = {
  CareemAddressSheet,
  AddressSheet,
};
